import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { RegoServerItem } from "../../Models/RegoServerItem";
import { KeyValue } from "../../Models/KeyValue";

const API_URL = process.env.REACT_APP_API_URL;

export const getDatabaseListAPI = async (serverUrl: string): Promise<RegoServerItem[]> => {
  return new Promise<RegoServerItem[]>((resolve, reject) => {
    axios
      .get<RegoServerItem[]>(`${API_URL}config/database?serverUrl=${encodeURI(serverUrl)}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const getOrderGroupListAPI = async (serverUrl: string, dbKey: string): Promise<KeyValue[]> => {
  return new Promise<KeyValue[]>((resolve, reject) => {
    axios
      .get<KeyValue[]>(`${API_URL}config/ordergrouplist?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const getBoxListAPI = async (serverUrl: string, dbKey: string): Promise<KeyValue[]> => {
  return new Promise<KeyValue[]>((resolve, reject) => {
    axios
      .get<KeyValue[]>(`${API_URL}config/boxlist?serverUrl=${encodeURI(serverUrl)}&dbKey=${dbKey}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
